import { useEffect, useState } from 'react';
import axios from 'axios';
import { MessageCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import WhatsAppNumberEditor from '@/components/WhatsAppNumberEditor';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => {
  const token = localStorage.getItem('salesspace_admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const StoreWhatsAppCard = () => {
  const [number, setNumber] = useState('');

  useEffect(() => {
    axios.get(`${API}/admin/settings/whatsapp`, { headers: authHeaders() })
      .then(({ data }) => setNumber(data.whatsapp || ''))
      .catch(() => {});
  }, []);

  return (
    <Card className="h-fit" data-testid="store-whatsapp-card">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <MessageCircle className="w-4 h-4 text-[#25D366]" /> Store WhatsApp
        </CardTitle>
        <p className="text-xs text-muted-foreground">Customers reach this number from your own products. Merchants set their own number.</p>
      </CardHeader>
      <CardContent>
        <WhatsAppNumberEditor
          endpoint="/admin/settings/whatsapp"
          initialValue={number}
          headers={authHeaders()}
          onSaved={setNumber}
          testIdPrefix="store-whatsapp"
        />
      </CardContent>
    </Card>
  );
};

export default StoreWhatsAppCard;
